module.exports = __webpack_public_path__ + "media/images/div_lens/racial-hispanic-09ce16df31b6ca65b8a94ab6d6b5bf42.png";